"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.submitOutreachTemplate = exports.addEmployee = exports.typeahead = exports.orderUp = exports.orderDown = exports.complete = exports.getOne = exports.getByProject = exports.deleteSegment = exports.update = exports.create = void 0;
var tslib_1 = require("tslib");
var api_1 = tslib_1.__importStar(require("./api"));
var omit_1 = tslib_1.__importDefault(require("lodash/omit"));
function create(segmentFormData) {
    var segmentData = segmentFormData;
    return api_1.default.post('/api/segment', segmentData).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.create = create;
function update(segmentId, segmentFormData) {
    var segmentData = (0, omit_1.default)(segmentFormData, ['projectId']);
    return api_1.default.post("/api/segment/".concat(segmentId), segmentData).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.update = update;
function deleteSegment(segmentId) {
    return api_1.default.delete("/api/segment/".concat(segmentId)).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.deleteSegment = deleteSegment;
function getByProject(projectId) {
    return api_1.default.get("/api/segment/project/".concat(projectId)).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getByProject = getByProject;
function getOne(segmentId) {
    return api_1.default.get("/api/segment/".concat(segmentId)).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getOne = getOne;
function complete(segmentId, value) {
    var payload = {
        complete: value,
    };
    return api_1.default.post("/api/segment/".concat(segmentId, "/complete"), payload).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.complete = complete;
function orderDown(segmentId) {
    return api_1.default.post("/api/segment/".concat(segmentId, "/order-down")).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.orderDown = orderDown;
function orderUp(segmentId) {
    return api_1.default.post("/api/segment/".concat(segmentId, "/order-up")).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.orderUp = orderUp;
function typeahead(query, searchBy) {
    var urls = {
        positions: '/api/position/typeahead?q=',
        companies: '/api/company/typeahead?q=',
        employees: '/api/employee/typeahead?positions=ANALYST&q=',
    };
    return api_1.default
        .get(urls[searchBy] + query)
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.typeahead = typeahead;
function addEmployee(segmentId, employeeId) {
    return api_1.default.post("/api/segment/".concat(segmentId, "/employee"), { employeeId: employeeId }).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.addEmployee = addEmployee;
function submitOutreachTemplate(segmentId, templateData) {
    return api_1.default
        .post("/api/segment/".concat(segmentId, "/submit-outreach-template"), templateData)
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.submitOutreachTemplate = submitOutreachTemplate;
var api = {
    create: create,
    update: update,
    deleteSegment: deleteSegment,
    getByProject: getByProject,
    getOne: getOne,
    complete: complete,
    orderDown: orderDown,
    orderUp: orderUp,
    typeahead: typeahead,
    addEmployee: addEmployee,
    submitOutreachTemplate: submitOutreachTemplate,
};
exports.default = api;
